import React from 'react';
import { translate } from 'react-i18next';
import { EmptyState, TextButton } from 'wix-style-react';
import ChevronRightSmall from 'wix-ui-icons-common/ChevronRightSmall';
import s from './ProfilePage.scss';

function NoProfile({ t, staticsBaseUrl }) {
  return (
    <div className={s.emptyState}>
      <EmptyState
        dataHook="profile-screen-empty-state"
        classNames={{ imageContainer: s.imageContainer }}
        image={
          <img
            src={`${staticsBaseUrl}assets/images/destructive-alert-generic-cables.svg`}
            width="169px"
            height="71px"
          />
        }
        theme="section"
        title={t('marketplace-user-explore-partners-profile-error-title')}
        subtitle={t(
          'marketplace-user-explore-partners-profile-error-description',
        )}
      >
        <TextButton
          as="a"
          href="/marketplace"
          suffixIcon={<ChevronRightSmall />}
        >
          {t('marketplace-user-explore-partners-profile-error-cta')}
        </TextButton>
      </EmptyState>
    </div>
  );
}

export default translate()(NoProfile);
